import { baseUrl } from "./baseUrl";

export const serviceProfilesRoute = (...params) => [`${baseUrl}`, ...params].join("/");

export const serviceProfilesVersionsRoute = (id) =>
  [`${baseUrl}`, `/offerings-api`, "/service-profiles", `/${id}`, "/versions"].join("");

export const updateProfilesVersionsRoute = (id, fromDate, force) =>
  [
    `${baseUrl}`,
    `/offerings-api`,
    "/service-profiles",
    `/${id}`,
    `?fromDate=${encodeURIComponent(fromDate)}`,
    `&force=${force}`,
  ].join("");

export const createProfilesRoute = () =>
  [`${baseUrl}`, `/offerings-api`, "/service-profiles"].join("");

export const deleteProfilesVersionsRoute = (id, toDate) =>
  [
    `${baseUrl}`,
    `/offerings-api`,
    "/service-profiles",
    `/${id}`,
    `?fromDate=${encodeURIComponent(toDate)}`,
  ].join("");
